import { ReportsGroupBy } from '@models/interfaces';

export type StructuralStatus = 'fail' | 'notRequired' | 'pass' | 'pending';
export type StructuralPassFailGroupKey = Extract<
  StructuralStatus,
  'fail' | 'pass'
>;
export type StructuralPassFailGroupBy =
  | ReportsGroupBy.ProjectType
  | ReportsGroupBy.State
  | ReportsGroupBy.Submarket;

export const STRUCTURAL_STATUS_LABELS: Record<StructuralStatus, string> = {
  fail: 'Fail',
  notRequired: 'Not Required',
  pass: 'Pass',
  pending: 'Pending',
};

export const STRUCTURAL_STATUS_COLORS: Record<StructuralStatus, string> = {
  fail: '#f64d4f',
  notRequired: '#949494',
  pass: '#03ffd2',
  pending: '#f2c94c',
};

export const STRUCTURAL_ANALYSIS_STATUS_ORDER: StructuralStatus[] = [
  'pass',
  'fail',
  'pending',
  'notRequired',
];

export const STRUCTURAL_PASS_FAIL_GROUP_KEYS: StructuralPassFailGroupKey[] = [
  'pass',
  'fail',
];

export const STRUCTURAL_PASS_FAIL_GROUP_BY_VALUES: StructuralPassFailGroupBy[] =
  [ReportsGroupBy.ProjectType, ReportsGroupBy.Submarket, ReportsGroupBy.State];

export const STRUCTURAL_PASS_FAIL_GROUP_TITLE_BY_GROUP_BY: Record<
  StructuralPassFailGroupBy,
  string
> = {
  [ReportsGroupBy.ProjectType]: 'Project Type',
  [ReportsGroupBy.State]: 'State',
  [ReportsGroupBy.Submarket]: 'Submarket',
};
